<div class="restaurant-container">
<app-restaurant-header></app-restaurant-header>

<app-page-header [header]="'Checkout'" [breadcrumbs]="[
    {label: 'Home',          url: root.home()},
    {label: ('CART.BREADCRUMB_CART' | translate), url: root.cart()},
    {label: 'Checkout',      url: ''}
]">

<div class="d-lg-none" style="display: flex; align-items: center">{{ 'CART.TOTAL' | translate }}:&nbsp;<b>{{cart.total$|async|currencyFormat}}</b></div>

</app-page-header>

<div class="checkout block">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-6 col-xl-7">
                <div class="card mb-lg-0">
                    <div class="card-body">
                        <h3 class="card-title">{{ 'CART.SHIPPING_DETAILS' | translate }}</h3>

                        <div class="address-card__row">
                            <div class="address-title">{{ 'CART.DESTINATION' | translate }}</div>
                            <div class="address-card__row-content">
                                <ng-container>
                                    {{ cart.destination.ragioneSocialeDestinazione }}<br>
                                    {{ cart.destination.indirizzoDestinazione }}<br>
                                    {{ cart.destination.cap }}
                                    {{ cart.destination.citta }}
                                    ({{ cart.destination.prov }})
                                </ng-container>
                            </div>
                        </div>

                        <div class="address-card__row">
                            <div class="address-title">{{ 'CART.SHIPPING_METHOD' | translate }}</div>
                            <div class="address-card__row-content">
                                {{ getModalitaDiSpedizione(cart.shippingMethod.tipo_spedizione) }}, {{cart.shippingCost | currencyFormat}}
                            </div>
                        </div>

                        <div class="address-card__row" *ngIf="cart.deliveryDate">
                            <div class="address-title">{{ 'CART.DELIVERY_DAY' | translate }}</div>
                            <div class="address-card__row-content">
                                {{formatDate(cart.deliveryDate)}}
                            </div>
                        </div>

                        <div class="address-card__row" *ngIf="cart.deliveryTime">
                            <div class="address-title">{{ 'CART.DELIVERY_TIME' | translate }}</div>
                                <div class="address-card__row-content">
                                    {{cart.deliveryTime.descrizione}}
                                </div>
                        </div>

                        <div class="address-card__row" *ngIf="cart.ritiroTime">
                            <div class="address-title">{{ 'CART.PICKUP_TIME' | translate }}</div>
                                <div class="address-card__row-content">
                                    {{formatDateRitiro(cart.ritiroTime)}}
                                </div>
                        </div>

                        <div class="address-card__row"
                            *ngIf="cart.note">
                            <div class="address-title">{{ 'CART.NOTES' | translate }}</div>
                            <textarea readonly class="form-control" rows="4">{{cart.note}}</textarea>
                        </div>

                    </div>
                </div>

                <div class="card mt-3">
                    <div class="card-body">
                        <h3 class="card-title">{{ 'CART.DISCOUNT_TITLE' | translate }}</h3>
                        <form class="cart__coupon-form" style="width: unset;">
                            <input [formControl]="controlCodiceSconto" type="text" class="form-control" placeholder="Codice sconto"
                                autocomplete="off">
                            <button type="submit" class="btn btn-primary" [ngClass]="{'btn-loading': checkingCodiceSconto}"
                            (click)="applyCode()">{{ 'CART.APPLY_DISCOUNT' | translate }}</button>
                        </form>
                        <div style="color:red" *ngIf="controlCodiceSconto.errors">
                            <small *ngIf="controlCodiceSconto.errors.empty">{{ 'CART.DISCOUNT_REQUIRED' | translate }}</small>
                            <small *ngIf="controlCodiceSconto.errors.notValid as notValid">{{notValid}}</small>
                            <small *ngIf="controlCodiceSconto.errors.greaterThanTotal; let error">{{ 'CART.DISCOUNT_TOO_HIGH' | translate:{sconto: (error.sconto | currencyFormat), totale: (error.totale | currencyFormat)} }}
                            </small>
                        </div>

                        <div *ngIf="availableCoupons?.length" class="mt-4 row">
                            <label class="col-12" style="color: #5c5c5c; font-weight: bold;">{{ 'CART.AVAILABLE_DISCOUNTS' | translate }}</label>
                            <div class="col-md-6 col-lg-12 col-xl-6 mt-2 mb-2" *ngFor="let coupon of availableCoupons">
                                <app-coupon [coupon]="coupon" [activeCouponCode]="cart.getCodiceSconto()"
                                    [totSpesa]="cart.subtotal" (discountEnd)="onDiscountEnd($event)"
                                    (onCouponSelected)="onCouponSelected($event)"></app-coupon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 col-xl-5 mt-4 mt-lg-0">
                <div class="card mb-0">
                    <div class="card-body">
                        <h3 class="card-title">{{ 'CART.ORDER_SUMMARY' | translate }}<div *ngIf="b2b" class="iva">IVA esclusa</div></h3>

                        <table class="checkout__totals" style="margin-bottom: 20px">
                            <thead class="checkout__totals-header">
                                <tr>
                                    <th>{{ 'CART.ITEM' | translate }}</th>
                                    <th class="col-qta">{{ 'CART.QTY' | translate }}</th>
                                    <th>{{ 'CART.TOTAL' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody class="checkout__totals-products">
                                <tr *ngFor="let item of cart.items$|async">
                                    <td>{{ item.product.descart }}
                                        <div style="color: gray;" *ngIf="item.product.conf_active as conf">
                                            {{conf.codice_confezione}} ({{conf.pezzi_confezione}} pz.) × {{item.quantity / conf.pezzi_confezione}}
                                        </div>
                                        <div *ngIf="item.options">{{getOptionLine(item.options)}}</div>
                                        <div *ngIf="item.box_levels && getBoxContentDescription(item.box_levels) as desc" class="tooltip_wider">
                                            <div *ngFor="let item of desc.slice(0, desc.length == 3 ? 3 : 2)">
                                                <div><small style="color: gray;">{{item}}</small></div>
                                            </div>

                                            <ng-template #compTemplate>
                                                <div *ngFor="let item of desc.slice(2)">{{item}}</div>
                                            </ng-template>
                                            <div *ngIf="desc.length != 3 && desc.length > 2">
                                                <small style="color: gray;">... e altri {{desc.length - 2}} <i class="fa fa-info-circle" 
                                                    style="cursor: pointer; color: #00adff"></i>
                                                </small>
                                            </div>
                                        </div>
                                        <div *ngIf="item.attributi" class="tooltip_wider">
                                            <div *ngFor="let item of item.attributi.slice(0, item.attributi.length == 3 ? 3 : 2)">
                                                <div><small style="color: gray;">+ {{item.descrizione}}</small></div>
                                            </div>
                                            <ng-template #attrTemplate>
                                                <div *ngFor="let item of item.attributi.slice(2)">+ {{item.descrizione}}</div>
                                            </ng-template>
                                            <div *ngIf="item.attributi.length != 3 && item.attributi.length > 2">
                                                <small style="color: gray;">... e altri {{item.attributi.length - 2}} <i class="fa fa-info-circle"
                                                    style="cursor: pointer; color: #00adff"></i>
                                                </small>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="col-qta">{{ item.quantity }}</td>
                                    <td>{{ cart.itemPriceWithAttributes(item, true) * item.quantity | currencyFormat }}</td>
                                </tr>
                            </tbody>
                            <tbody class="checkout__totals-subtotals">
                                <tr>
                                    <th>{{ 'CART.SUBTOTAL' | translate }}</th>
                                    <td colspan="2">{{ cart.subtotal$|async|currencyFormat }}</td>
                                </tr>
                            </tbody>
                            <tbody class="checkout__totals-subtotals">
                                <tr>
                                    <th>{{ 'CART.SHIPPING' | translate }}<br><span style="font-weight: normal;">{{getModalitaDiSpedizione(cart.shippingMethod.tipo_spedizione)}}</span></th>
                                    <td colspan="2">{{cart.shippingCost | currencyFormat }}</td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="cart.sconto" class="checkout__totals-subtotals">
                                <tr>
                                    <th>{{ 'CART.DISCOUNT_CODE' | translate }}<br><span style="font-weight: normal;">{{cart.sconto.codice}} (-{{ cart.sconto.indicatore_percentuale_assoluto ? (cart.sconto.valore | currencyFormat) :  cart.sconto.valore + '%' }})</span></th>
                                    <td colspan="2">-{{cart.scontoValue | currencyFormat }}</td>
                                </tr>
                            </tbody>
                            <tbody class="checkout__totals-subtotals">
                                <tr>
                                    <td colspan="3" style="text-align: unset; padding-right: 0;">
                                        <div class="payment-methods">
                                            <span class="address-title">{{ 'CART.PAYMENT_METHOD' | translate }}</span>
                                            <ul class="payment-methods__list">
                                                <li class="payment-methods__item payment-methods__item--active" *ngFor="let payMethod of metodiDiPagamento">
                                                    <label class="payment-methods__item-header">
                                                        <span class="payment-methods__item-radio input-radio">
                                                            <span class="input-radio__body">
                                                                <input [formControl]="controlPayMethod" class="input-radio__input" [value]="payMethod.codice" type="radio">
                                                                <span class="input-radio__circle"></span>
                                                            </span>
                                                        </span>
                                                        <span class="payment-methods__item-title">{{payMethod.descrizione}}</span>
                                                        <span class="payment-methods__item-value"
                                                            [ngClass]="!payMethod.valore || !payMethod.flag_sconto_maggiorazione ? 'text-success': 'text-danger'">{{cart.formatPayMethodPrice(payMethod)}}</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tfoot class="checkout__totals-footer">
                                <tr>
                                    <th>{{ 'CART.TOTAL' | translate }}</th>
                                    <td colspan="2">{{ cart.total$|async|currencyFormat }}</td>
                                </tr>
                            </tfoot>
                        </table>

                        <div class="checkout__agree form-group" style="margin-bottom: 20px" *ngIf="store.price == 'b2c'">
                            <div class="form-check">
                                    <span class="form-check-input input-check">
                                        <span class="input-check__body">
                                            <input [formControl]="controlFatturaRequired" class="input-check__input" type="checkbox" id="fattura-richiesta">
                                            <span class="input-check__box"></span>
                                            <svg class="input-check__icon" width="9px" height="7px"><use xlink:href="assets/images/sprite.svg#check-9x7"></use></svg>
                                        </span>
                                    </span>
                                <label class="form-check-label" for="fattura-richiesta">
                                   {{ 'CART.REQUEST_INVOICE' | translate }}
                                </label>
                            </div>
                        </div>

                        <button (click)="confirmOrder()" type="submit" class="btn btn-primary-darken btn-xl btn-block"
                        [disabled]="loading"
                        [ngClass]="{'btn-loading': loading}">{{ 'CART.CONFIRM_ORDER' | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
   </div>
    <app-restaurant-footer></app-restaurant-footer>